// axios module
import axios from "axios";

// craete base url
export const API = axios.create({
  baseURL: "https://api-crm-poshakomid.metanext.biz/api",
});

// get id from localStorage
const res = JSON.parse(localStorage.getItem("profile"));
const token = res?.success?.token;
export let IdUser = res?.users[0]?.IdUser;

// Request interceptors for API calls
API.interceptors.request.use(
  (config) => {
    config.headers.common["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const API_UPLOAD = axios.create({
  baseURL: "https://api-crm-poshakomid.metanext.biz/api",
});

API_UPLOAD.interceptors.request.use(
  (config) => {
    config.headers.common["Authorization"] = `Bearer ${token}`;
    config.headers.post["Content-Type"] = "multipart/form-data";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const setHeaderAPI = () => {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const updateToken = profile?.success?.token;
  IdUser = profile?.users[0]?.IdUser;
  API.defaults.headers["Authorization"] = `Bearer ${updateToken}`;
  API_UPLOAD.defaults.headers["Authorization"] = `Bearer ${updateToken}`;
};
